<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.75 5.27864C10.75 4.86443 10.4142 4.52864 10 4.52864C9.58579 4.52864 9.25 4.86443 9.25 5.27864V10.0009C9.25 10.247 9.37074 10.4774 9.57309 10.6175L13.1842 13.1175C13.5248 13.3533 13.992 13.2683 14.2278 12.9278C14.4635 12.5872 14.3786 12.12 14.038 11.8842L10.75 9.6079V5.27864Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 1.19531C5.13684 1.19531 1.19446 5.13769 1.19446 10.0009C1.19446 14.864 5.13684 18.8064 10 18.8064C14.8632 18.8064 18.8056 14.864 18.8056 10.0009C18.8056 5.13769 14.8632 1.19531 10 1.19531ZM2.69446 10.0009C2.69446 5.96612 5.96527 2.69531 10 2.69531C14.0348 2.69531 17.3056 5.96612 17.3056 10.0009C17.3056 14.0356 14.0348 17.3064 10 17.3064C5.96527 17.3064 2.69446 14.0356 2.69446 10.0009Z"
            fill="currentColor"
        />
    </svg>
</template>
